import { createStore } from "jotai";

export const tizenStore = createStore();
